import React, { ReactElement } from 'react'
import Icon from '@ant-design/icons'

const ClosedSvg = (): ReactElement => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_757_7464)">
      <path d="M30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5C46.2924 0.5 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5Z" stroke="#72C040"/>
      <path d="M43.394 19.2188H41.0536C40.7254 19.2188 40.4141 19.3694 40.2132 19.6272L26.4085 37.115L19.789 28.7277C19.6889 28.6005 19.5613 28.4977 19.4157 28.427C19.2702 28.3562 19.1105 28.3194 18.9486 28.3192H16.6082C16.3839 28.3192 16.26 28.577 16.3973 28.7511L25.5681 40.3694C25.9966 40.9118 26.8203 40.9118 27.2522 40.3694L43.6049 19.6473C43.7422 19.4766 43.6183 19.2188 43.394 19.2188V19.2188Z" fill="#72C040"/>
    </g>
    <defs>
      <clipPath id="clip0_757_7464">
        <rect width="60" height="60" fill="white"/>
      </clipPath>
    </defs>
  </svg>

)

export const ClosedIcon = (props): ReactElement => <Icon component={ClosedSvg} {...props} />
